import { useEffect, useState } from 'react';
import Menu from './Header/Menu';
import Content from './Main/Content';
import AccessNav from './AccessibilityNav/AccessNav';
import { useVersionControlStore } from '../@iosper/components/VersionControl/store/hooks';
import Mantenimiento from './Messages/Page/Mantenimiento';
import SnackbarMessages from './Messages/SnackbarMessages';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import { MenuMobile } from './Header/MenuMobile';

export const Layouts = () => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { state, dispatchCheckVersion } = useVersionControlStore();
  const [isUpdated, setIsUpdated] = useState(true);

  useEffect(() => {
    dispatchCheckVersion();
  }, []);

  useEffect(() => {
    setIsUpdated(state.isUptodate);
  }, [state]);

  return (
    <>
      {/* PAGINA DE MANTENIMIENTO */}
      {!isUpdated && <Mantenimiento />}

      {/* APLICACION */}
      {isUpdated && (
        <>
          {/* MOBILE */}
          {isMobileScreen && (
            <>
              <MenuMobile>
                <Content />
              </MenuMobile>
              <SnackbarMessages />
            </>
          )}

          {/* DESKTOP */}
          {!isMobileScreen && (
            <>
              <header>
                <AccessNav />
              </header>
              <Menu>
                <Content />
              </Menu>
              <SnackbarMessages />
            </>
          )}
        </>
      )}
    </>
  );
};
